<template>
    <div class="table-responsive">
        <table class="table table-grid table-inline table-selectable table-outer-bordered">
            <thead>
                <tr>
                    <th><checkbox :checked="allGroupsEnabled" @click.prevent="toggleAllGroups" /></th>
                    <th>Group</th>
                    <th>Role</th>
                </tr>
            </thead>
            <tbody>
                <tr
                    v-for="item in groups"
                    :key="item.locationGroupID"
                    :class="{ highlighted: item.enabled }"
                >
                    <td>
                        <checkbox v-model="item.enabled" @change="onChanged" />
                    </td>
                    <td class="pr-3">{{item.name}}</td>
                    <td>
                        <select v-control v-model="item.role" :style="{ opacity: item.enabled ? 1 : 0 }" @change="onChanged">
                            <option value="1">Member</option>
                            <option value="2">Group admin</option>
                        </select>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
    import _ from 'lodash';
	import { AsyncMixin } from 'pdk/mixins';
    import { account } from '@/services';


	export default {
		name: 'user-group-selector',
        mixins: [AsyncMixin],
        props: {
            currentGroups: Array
        },
        data() {
            return {
                groups: undefined
            };
        },
        computed: {
            allGroupsEnabled() {
                return _.every(this.groups, (g) => g.enabled);
            },
            selectedGroups() {
                return _.filter(this.groups, (g) => g.enabled);
            }
        },
        created() {
            this.async(account.getUserGroups({
                role: 2 // Group Admin
            }))
            .then((groups) => {
                for (var i = 0; i < groups.length; i++) {
                    groups[i].enabled = false;
                    groups[i].role = 1; // Member
                }

                if (this.currentGroups) {
                    this.groups = _.filter(groups, (g) => !_.some(this.currentGroups, (cg) => g.locationGroupID === cg.locationGroupID));
                }
                else {
                    this.groups = groups;
                }
            });
		},
        methods: {
            toggleAllGroups() {
                const enabled = !this.allGroupsEnabled;

                for (var i = 0; i < this.groups.length; i++) {
                    this.groups[i].enabled = enabled;
                }

                this.$emit('change', this.selectedGroups);
            },
            onChanged() {
                this.$emit('change', this.selectedGroups);
            }
        }
    };
</script>